import PollingModal from "@/components/PollingModal";
import { FormatTime } from "@/lib/constants";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import { Stack, Typography } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const PennyDropPollingModal = forwardRef(
  ({ open, data, handleModal, btnOnClick, btnDisabled, pollingStart }, ref) => {
    const { totalPollingTime } = data;
    const startTimeInSeconds = Math.ceil(totalPollingTime / 1000);
    const InitialTimeLeft = FormatTime(startTimeInSeconds);

    const [timeLeft, setTimeLeft] = useState(InitialTimeLeft);

    const isPolling = pollingStart;

    useImperativeHandle(ref, () => {
      return {
        resetTimeLeft: () => setTimeLeft(InitialTimeLeft),
        getState: () => ({ timeLeft, open }),
      };
    }, [InitialTimeLeft, open]);

    useEffect(() => {
      if (!isPolling) return;

      const timer = setInterval(() => {
        setTimeLeft((prev) => {
          const [mins, secs] = prev.split(":").map(Number);
          const totalSeconds = Math.max(mins * 60 + secs - 1, 0);
          return FormatTime(totalSeconds);
        });
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }, [isPolling]);

    const TimeLabel = () => {
      if (!isPolling || timeLeft === "00:00") return "Retry";
      return (
        <Stack alignItems={"center"} flexDirection={"row"} gap={1}>
          <Typography display={"flex"} alignItems={"center"} gap={1}>
            {" "}
            <TimerOutlinedIcon /> Retry available in
          </Typography>
          <Typography width={"50px"}>{timeLeft}</Typography>
        </Stack>
      );
    };

    return (
      <PollingModal
        open={open}
        handleModal={handleModal}
        btnOnClick={btnOnClick}
        label="Bank Account Verification in Progress"
        sublabel="We are verifying the bank account details provided by you."
        text="A small amount is being deposited into your account for verification purposes, in accordance with regulatory requirements."
        showBtn={true}
        btnDisabled={btnDisabled}
        btnLabel={<TimeLabel />}
      />
    );
  },
);

export default PennyDropPollingModal;
